import { Origin } from '@/app/graphql/notification/sdk.notification';
import { Operations, Status } from '@/app/graphql/payment/sdk.payment';

export enum WebSocketTopics {
  USER_NOTIFICATION = '/user/notification',
}

export interface NotificationLineWebSocketMessage {
  id: number;
  status: string;
  date: string;
  time: string;
  text: string | null;
  title: string;
  recipient: string;
  dateTime: string;
  origin: Origin;
  classList: string;
  icon: string;
  payload: string | NotificationPayment | NotificationStatement | NotificationLetter | NotificationSalary;
  color: string;
  countStatement?: number;
  legalPartyName?: string;
  idGroup?: number[];
}

export interface NotificationPaymentMessage extends NotificationLineWebSocketMessage {
  payload: NotificationPayment;
}
export interface NotificationLetterMessage extends NotificationLineWebSocketMessage {
  payload: NotificationLetter;
}
export interface NotificationSalaryMessage extends NotificationLineWebSocketMessage {
  payload: NotificationSalary;
}
export interface NotificationStatementMessage extends NotificationLineWebSocketMessage {
  payload: NotificationStatement;
  idGroup: number[];
}
export interface NotificationPayment {
  legalPartyId: number;
  paymentId: number;
  transferNum: string;
  operationCode: Operations;
  status: Status;
  amount: number;
  currency: string;
}

export interface NotificationLetter {
  letterId: number;
  legalPartyId: number;
  referenceId: number;
}

export interface NotificationSalary {
  salaryId: number;
  legalPartyId: number;
  legalPartyName: string;
  referenceId: number;
  status: Status;
  amount: number;
  currency: string;
}

export interface NotificationStatement {
  legalPartyId: number;
  paymentId: number;
  transferNum: string;
  operationCode: Operations;
  status: Status;
  amount: number;
  currency: string;
}

export function isNotificationPaymentService(
  something: NotificationLineWebSocketMessage
): something is NotificationPaymentMessage {
  return something.origin === Origin.Payment && !!(something.payload as NotificationPayment)?.status;
}

export function isNotificationLetterService(
  something: NotificationLineWebSocketMessage
): something is NotificationLetterMessage {
  return (
    something.origin === Origin.Letter &&
    !!(something.payload as NotificationLetter)?.letterId &&
    !!(something.payload as NotificationLetter)?.legalPartyId
  );
}

export function isNotificationStatementService(
  something: NotificationLineWebSocketMessage
): something is NotificationStatementMessage {
  return something.origin === Origin.Statement;
}

export function isNotificationSalaryService(
  something: NotificationLineWebSocketMessage
): something is NotificationSalaryMessage {
  return something.origin === Origin.Salary;
}
